import { createPostAsyncSlice } from '@sonar-software/xuder';
import { postOnboardingEnroll } from '../../../api';
import { setJWTToken } from '@sonar-software/sonar-ts-lib';

export const securityAuthenticationEnrollPostAsyncSlice = createPostAsyncSlice({
	httpSagaOptions: {
		successDataHandlers: [
			(response) => {
				setJWTToken(response.userIdToken);
			}
		]
	},
	name: 'SecurityAuthenticationEnroll',
	receive: false,
	request: true,
	requestHandler: postOnboardingEnroll
});
